import Lottie from 'lottie-react';
import Box from '@mui/material/Box/Box';

import loader from '../../assets/grey-loader.json';

export function PaypalButtonLoader() {
  return (
    <Box bgcolor="#ffc439" borderRadius={1} width={'100%'} height={44} position="relative">
      <Lottie
        animationData={loader}
        className="loader-animation"
        size={50}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      />
    </Box>
  );
}
